export const iconFontAwesomeHumanitarianPersonFalling = (
	<i className="fa-solid fa-person-falling"></i>
);
